import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { Layout } from './Layout';
import { metaOverrideSet } from '../metaOverrideSet';

export const Template = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <MetaResourceRenderer
      resource={pageContentResource}
      layout={Layout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};
